module.exports = __webpack_public_path__ + "static/media/map_GPS_line_icon_mini.55aef0dd.svg";